import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import LayoutHeaderButton from './components/button/index';

import './styles.pcss';

const propTypes = {
  className: PropTypes.string,
  sectionLeft: PropTypes.node,
  sectionRight: PropTypes.node,
};
const defaultProps = {
  className: undefined,
  sectionLeft: null,
  sectionRight: null,
};

export default function LayoutHeader({
  className,
  sectionLeft,
  sectionRight,
}) {
  return (
    <div className={cn(className, 'layout-header')}>
      <div className="layout-header__section layout-header__section_left">
        {sectionLeft}
      </div>
      {sectionRight && <div className="layout-header__section layout-header__section_right">{sectionRight}</div>}
    </div>
  );
}

LayoutHeader.Button = LayoutHeaderButton;

LayoutHeader.propTypes = propTypes;
LayoutHeader.defaultProps = defaultProps;
